


















































































//本页面为问政榜单
import { Component, Vue } from "vue-property-decorator";
import { dateFormat } from "@/common/Utils";
import { Picker as vanPicker, Popup as vanPopup } from "vant";
import request from "@/api/index";
import { IWenzhengScoreResponse, IWenzhengScore } from "@/api/types";

interface IOption {
  text: string;
  time: string;
  id: string | number;
  startTime: string;
  endTime: string;
}
@Component({
  components: {
    vanPicker,
    vanPopup
  }
})
export default class App extends Vue {
  isShowRules = false;

  isShowDateSelect = false;
  columns: IOption[] = [];
  chooseItem: IOption = {} as IOption;
  defaultIndex = 0;

  listParams: any = {
    appId: "",
    beginTime: "2021-10-1",
    endTime: "2021-12-1",
    sortColumn: ""
  };
  list: IWenzhengScore[] = [];
  mounted() {
    this.listParams.appId = (this.$route.query.appId as string) || "28";
    document.title = "问政榜单";

    this.caculateDateList();
    this.listParams.beginTime = this.chooseItem.startTime;
    this.listParams.endTime = this.chooseItem.endTime;
    this.getList();

    ZWY_CLOUD.topBarConfig({
      isShowTop: 1,
      isShowBackBtn: 1,
      isShowTitle: "问政榜单",
      isShowMoreBtn: "1"
    });
    ZWY_CLOUD.shareConfig({
      id: "",
      shareTitle: "看万州问政榜单",
      shareDescription: "",
      sourceType: "1",
      shareImgUrl: "https://imagecdn.cqliving.com/images/icon/28.png",
      shareUrl: window.location.href,
      shareUrlQQ: window.location.href,
      shareUrlQzone: window.location.href,
      shareUrlWx: window.location.href,
      shareUrlWxMoments: window.location.href,
      shareUrlWeibo: window.location.href
    });
  }
  caculateDateList() {
    const number = 12;
    for (let i = 0; i < number; i++) {
      const nowDate = new Date();
      nowDate.setMonth(nowDate.getMonth() - i);
      if (i == 0) {
        let startTime = "",
          startTimeTxt = "",
          endTime = "",
          endTimeTxt = "";
        endTime = dateFormat(nowDate, "yyyy-MM-dd");
        endTimeTxt = dateFormat(nowDate, "MM.dd");
        nowDate.setDate(1);
        startTime = dateFormat(nowDate, "yyyy-MM-dd");
        startTimeTxt = dateFormat(nowDate, "MM.dd");
        this.columns.push({
          startTime,
          endTime,
          id: i,
          text:
            dateFormat(nowDate, "yyyy年MM月") +
            "（" +
            startTimeTxt +
            "-" +
            endTimeTxt +
            "）",
          time: ""
        });
      } else {
        let startTime = "",
          startTimeTxt = "",
          endTime = "",
          endTimeTxt = "";
        nowDate.setDate(1);
        startTime = dateFormat(nowDate, "yyyy-MM-dd");
        startTimeTxt = dateFormat(nowDate, "MM.dd");

        const month = nowDate.getMonth() + 1;
        const fullYear = nowDate.getFullYear();
        const endOfMonth = new Date(fullYear, month, 0);
        endTime = dateFormat(endOfMonth, "yyyy-MM-dd");
        endTimeTxt = dateFormat(endOfMonth, "MM.dd");
        this.columns.push({
          startTime,
          endTime,
          id: i,
          text:
            dateFormat(nowDate, "yyyy年MM月") +
            "（" +
            startTimeTxt +
            "-" +
            endTimeTxt +
            "）",
          time: ""
        });
      }
    }

    // 设置默认值
    const now = new Date();
    if (now.getDate() == 1) {
      this.defaultIndex = 1;
    } else {
      this.defaultIndex = 0;
    }
    this.chooseItem = this.columns[this.defaultIndex];
  }

  toCheckRule() {
    this.isShowRules = true;
  }
  toSlectDate() {
    this.isShowDateSelect = true;
  }
  onConfirm(data: IOption) {
    this.chooseItem = data;
    this.isShowDateSelect = false;

    this.listParams.beginTime = this.chooseItem.startTime;
    this.listParams.endTime = this.chooseItem.endTime;
    this.getList();
  }

  getList() {
    request
      .wenzhangRanking(this.listParams)
      .then((res: IWenzhengScoreResponse) => {
        if (res.code >= 0) {
          this.list = res.data;
        }
      });
  }

  toDetail() {
    this.$router.push({
      path: "/wenzhengRankingDetail",
      query: {
        beginTime: this.listParams.beginTime,
        endTime: this.listParams.endTime,
        appId: this.listParams.appId
      }
    });
  }
}
